import { makeStyles } from "@material-ui/core";
const useStyles = makeStyles({}, { index: 1 });
export default useStyles;
